/**
 * Short-lived storage for what the visitor typed on /get-started before they
 * signed in.
 *
 * The happy path does not need this: sign-in uses a popup, so the page stays
 * mounted and the account name is still in React state when the popup closes.
 * The draft exists for the paths where the page IS torn down — a reload
 * mid-flow, or a browser that forces the redirect flow — so the visitor does not
 * lose what they typed.
 *
 * sessionStorage rather than localStorage: it is scoped to the tab and dies with
 * it, so an abandoned sign-up cannot resurface in a later session.
 */
var KEY = 'ltiaas.signup';
/** Drafts older than this are ignored — a stale name is worse than an empty field. */
var MAX_AGE_MS = 60 * 60 * 1000;
/**
 * Every access is guarded: Safari in private mode throws on sessionStorage, and
 * losing a draft must never break sign-up.
 */
export var saveSignupDraft = function (accountName, planSlug) {
    try {
        if (!accountName || accountName.trim() === '') {
            window.sessionStorage.removeItem(KEY);
            return;
        }
        var draft = {
            accountName: accountName,
            planSlug: planSlug,
            createdAt: Date.now(),
        };
        window.sessionStorage.setItem(KEY, JSON.stringify(draft));
    }
    catch (e) {
        /* storage unavailable — the in-memory path still works */
    }
};
export var readSignupDraft = function () {
    try {
        var raw = window.sessionStorage.getItem(KEY);
        if (!raw) {
            return null;
        }
        var draft = JSON.parse(raw);
        if (!draft || typeof draft.accountName !== 'string' || typeof draft.createdAt !== 'number') {
            return null;
        }
        if (Date.now() - draft.createdAt > MAX_AGE_MS) {
            clearSignupDraft();
            return null;
        }
        return {
            accountName: draft.accountName,
            planSlug: typeof draft.planSlug === 'string' ? draft.planSlug : null,
            createdAt: draft.createdAt,
        };
    }
    catch (e) {
        return null;
    }
};
export var clearSignupDraft = function () {
    try {
        window.sessionStorage.removeItem(KEY);
    }
    catch (e) {
        /* nothing to do */
    }
};
